import { lazyLoad } from 'utils/loadable';

export const FacilityDetailsLoadable = lazyLoad(
  () => import('./FacilityDetails'),
  module => module.FacilityDetails,
);
